var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    staticClass: "fill-height d-flex flex-column"
  }, [_c('v-card-text', [_c('v-expansion-panels', {
    attrs: {
      "flat": "",
      "mandatory": ""
    }
  }, [_vm._l(_vm.sides, function (side) {
    return [_c('side-list', _vm._b({
      key: side,
      model: {
        value: _vm.form,
        callback: function ($$v) {
          _vm.form = $$v;
        },
        expression: "form"
      }
    }, 'side-list', {
      side
    }, false))];
  })], 2), _c('side-file', {
    staticClass: "mt-16",
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }